// react
import React from 'react';
import styled from 'styled-components';

// components
import { BaseField, FieldProps } from '@/components/atoms/BaseField/BaseField';

/**
 * ReadOnlyField allows you to add a read only field to your form.
 */
export const ReadOnlyField = ({
  id,
  label,
  description,
  value,
  isRequired = false,
  isHideTitle = false,
}: ReadOnlyFieldProps) => {
  return (
    <BaseField
      id={id}
      label={label}
      description={description}
      isRequired={isRequired}
      isHideTitle={isHideTitle}
    >
      <StyledReadOnly>{value}</StyledReadOnly>
    </BaseField>
  );
};

const StyledReadOnly = styled.div`
  display: flex;
  font: ${(props) => props.theme.typography.body.sm.regular};
  color: ${(props) => props.theme.color.neutral[80]};
  padding: ${(props) => props.theme.spacing[12]} 0;
  border-bottom: 1px solid ${(props) => props.theme.color.neutral[50]};
`;

interface ReadOnlyFieldProps extends FieldProps<string> {}

ReadOnlyField.displayName = 'ReadOnlyField';

export default ReadOnlyField;
